import { ProductSession } from '@big-red-group/storefront-common-checkout'

export const getRetailPrice = (sessions: ProductSession[]): number | undefined => {
  const option = sessions
    .flatMap((session) => session.productOptions)
    .find((option) => option.isFromPrice && option.retailPrice)
  return option?.retailPrice
}
